export const BOOKS = [
  {
    id: 1,
    num: "01",
    title: "Lil Momma & Man-Man",
    subtitle: "Cousins Learning When a Joke Goes Too Far?",
    badge: "Book 1 · Kindness & Boundaries",
    tagline:
      "A funny, heartwarming lesson on empathy, respect, and knowing the moment a joke stops being funny.",
    cover: "/covers/book1.webp",
    amazon: "https://www.amazon.com/Lil-Momma-Man-Man-Learning-Yourself/dp/B0HL5VDT58",
    color: "#D92B38",
    preview: [
      {
        heading: "The Hallway",
        text: "Man-Man's joke had the whole hallway laughing. Everybody, that is, except one person — and that person's silence was louder than all the laughs.",
      },
      {
        heading: "The Lesson",
        text: "Lil Momma tugged his jersey and leaned in close. “Cuz… a joke is only funny when everybody gets to smile.”",
      },
    ],
  },
  {
    id: 2,
    num: "02",
    title: "Bruh, I Got This!",
    subtitle: "The Captain Takes Charge of His Health",
    badge: "Book 2 · Health & Leadership",
    tagline:
      "Football Captain #76 Man-Man learns that taking care of your body is the ultimate captain move.",
    cover: "/covers/book2.webp",
    amazon: "https://www.amazon.com/Bruh-This-Believe-Yourself-Matter/dp/B0HJHP4QS7",
    color: "#1B365D",
    preview: [
      {
        heading: "Fourth Quarter",
        text: "Captain #76 never backed down from a tackle. But the snacks after every practice? Those were tackling HIM.",
      },
      {
        heading: "Taking Charge",
        text: "“Bruh, I got this,” Man-Man said, trading the chips for apple slices. “A captain takes charge — starting with himself.”",
      },
    ],
  },
  {
    id: 3,
    num: "03",
    title: "Hey, Lil Momma",
    subtitle: "Believe in Yourself, No Matter Your Size",
    badge: "Book 3 · Body Positivity & Self-Love",
    tagline:
      "Cheerleader Lil Momma shares a powerful message on confidence, body positivity, and inner strength.",
    cover: "/covers/book3.webp",
    amazon: "https://www.amazon.com/Hey-Lil-Momma-Believe-Yourself/dp/B0HHJNQC36",
    color: "#E5A922",
    preview: [
      {
        heading: "Tryout Day",
        text: "Lil Momma stood at the edge of the gym, pom-poms ready, butterflies doing backflips in her belly.",
      },
      {
        heading: "Her Moment",
        text: "“Believe in yourself,” she whispered, “no matter your size.” Then she cartwheeled straight into her own spotlight.",
      },
    ],
  },
  {
    id: 4,
    num: "04",
    title: "Lil Momma & Man-Man",
    subtitle: "A Spooky Halloween Adventure!",
    badge: "Halloween Special · Courage & Fun",
    tagline:
      "The cousins brave a night of spooky surprises and learn that courage shines brightest when you believe in yourself.",
    cover: "/covers/book4.webp",
    amazon: "https://www.amazon.com/dp/B0HM26SFVT",
    color: "#E8761A",
    preview: [
      {
        heading: "One Spooky Night",
        text: "The house at the end of Maple Street glowed orange. Lil Momma squeezed Man-Man's hand. “Cousins stick together — even when it's spooky.”",
      },
      {
        heading: "Brave Hearts",
        text: "Every creak and shadow melted away once they remembered: courage isn't never being scared — it's believing in yourself anyway.",
      },
    ],
  },
  {
    id: 5,
    num: "05",
    title: "Lil Momma & Man-Man",
    subtitle: "Color Your Story!",
    badge: "Activity Book · Color, Play & Journal",
    tagline:
      "Coloring pages, word searches, trivia, and journal entries — kids grab the pen and create their own adventure.",
    cover: "/covers/book5.webp",
    amazon: "https://www.amazon.com/Lil-Momma-Man-Man-believe-yourself-ebook/dp/B0HMP68KHH",
    color: "#2F8F5B",
    preview: [
      {
        heading: "Color, Play & Journal",
        text: "Coloring pages starring Lil Momma & Man-Man, word searches packed with story words, cousin trivia, and journal pages that ask: what will YOU write today?",
      },
      {
        heading: "You Hold the Pen",
        text: "Every page ends the same way — with space for your own story. Because nobody can tell it like you can.",
      },
    ],
  },
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};
